import Vue from 'vue';
export default Vue.component('ed-h3', { name: 'ed-h3'});